import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {entities} from '../../util/uiconstants';
import {findEntityUidInsideTree} from './helper';
import _ from 'lodash';

export function sectionRelatedObjectsReducer(state = initialstate.sectionRelatedObjects, action) {
	switch (action.type) {
		case types.GET_SECTION_RELATED_OBJECTS: {
			let currentSectionId = action.sectionId,
				includeEntityName = action.includeEntityName,
				fsroParentCount = 0,
				fsroChildCount = 0,
				fsroTreeList = [],
				newFsroTreeList = [];
			if (action.response) {
				if (action.response.length > 0) {
					fsroTreeList = action.response;
					if (
						fsroTreeList.some(
							(parent) => parent.parentEntityId === entities.Control && parent.entityId === entities.ItSoApplication
						)
					) {
						newFsroTreeList = fsroTreeList.filter(
							(parent) => parent.parentFormSectionRelatedObjectId === null && parent.entityId !== entities.Control
						);
						fsroParentCount = fsroTreeList.filter(
							(parent) => parent.parentFormSectionRelatedObjectId === null && parent.entityId !== entities.Control
						).length;
						fsroChildCount = Number(fsroTreeList.length) - Number(fsroParentCount);
					} else {
						fsroParentCount = fsroTreeList.filter((parent) => parent.parentFormSectionRelatedObjectId === null).length;
						fsroChildCount = Number(fsroTreeList.length) - Number(fsroParentCount);
					}

					if (
						includeEntityName &&
						fsroTreeList.some(
							(parent) => parent.parentEntityId === entities.Control && parent.entityId === entities.ItSoApplication
						)
					) {
						fsroTreeList = _.cloneDeep(GetSectionRelatedObjectTreeForChildToParent(action.response));
					} else {
						fsroTreeList = _.cloneDeep(GetSectionRelatedObjectTree(action.response));
					}
				}

				return {
					...state,
					[currentSectionId]: {
						fsroTreeList: fsroTreeList,
						newFsroTreeList: newFsroTreeList,
						fsroParentCount: fsroParentCount,
						fsroChildCount: fsroChildCount
					}
				};
			} else {
				// API call failed. Do not modify the store
				return state;
			}
		}
		case types.UPDATE_SECTION_RELATEDOBJECTS_AFTER_RESPONSE: {
			let newState = JSON.parse(JSON.stringify(state));
			if (action.response) {
				let fsro = findSectionRelatedObjects(newState[action.response.sectionId].fsroTreeList, action.response);
				fsro.forEach((data) => {
					data.entityName = action.response.entityName;
					data.strategyTypeId = action.response.strategyTypeId;
					data.riskTypeId = action.response.riskTypeId;
					(data.controlFrequencyTypeId = action.response.controlFrequencyTypeId),
						(data.controlTypeId = action.response.controlTypeId),
						(data.iTApplications = action.response.iTApplications),
						(data.designEffectiveness = action.response.designEffectiveness),
						(data.isEffective = action.response.isEffective),
						(data.hasControlTesting = action.response.hasControlTesting),
						(data.isLowerRisk = action.response.isLowerRisk),
						(data.controlFrequencyTypeId = action.response.controlFrequencyTypeId),
						(data.itApproachTypeId = action.response.itApproachTypeId),
						(data.isEffective = action.response.isEffective),
						(data.hasitcontroltesting = action.response.hasControlTesting);
				});
			}
			return newState;
		}
		case types.DELETE_SECTION_RELATED_OBJECTS: {
			if (!action.error) {
				let list = findObjectAndRemove(state[action.sectionId].fsroTreeList, action.item),
					newList =
						action.item.entityId === entities.ItSoApplication
							? findObjectAndRemove(state[action.sectionId].newFsroTreeList, action.item)
							: [];

				let fsroTreeList = list,
					fsroParentCount =
						action.item.entityId === entities.ItSoApplication
							? newList.length
							: list.filter((parent) => parent.parentFormSectionRelatedObjectId === null).length,
					fsroChildCount = 0;

				if (list && list.length > 0) {
					for (let i = 0; i < list.length; i++) {
						if (list[i].children && list[i].children.length > 0) {
							fsroChildCount = fsroChildCount + list[i].children.length;
						}
					}
				}

				return {
					...state,
					[action.sectionId]: {
						fsroTreeList: fsroTreeList,
						newFsroTreeList: newList,
						fsroParentCount: fsroParentCount,
						fsroChildCount: fsroChildCount
					}
				};
			}
		}
		case types.CREATE_SECTION_RELATED_OBJECTS: {
			if (!action.error && action.response) {
				let currentList = _.cloneDeep(state[action.response.formSectionId].fsroTreeList),
					newCurrentList =
						action.item.entityId === entities.ItSoApplication
							? _.cloneDeep(state[action.response.formSectionId].newFsroTreeList)
							: [];

				if (action.response) {
					action.response.entityName = action.item.name;
					action.response.riskTypeId = action.item.riskTypeId;
					action.response.strategyTypeId = action.item.strategyTypeId;
				}
				currentList.push(action.response);
				newCurrentList.push(action.response);

				let list = _.cloneDeep(GetUpdatedSectionRelatedObjectTree(currentList));
				let fsroTreeList = list,
					fsroParentCount =
						action.item.entityId === entities.ItSoApplication
							? newCurrentList.length
							: list.filter((parent) => parent.parentFormSectionRelatedObjectId === null).length,
					fsroChildCount = 0;

				if (list && list.length > 0) {
					for (let i = 0; i < list.length; i++) {
						if (list[i].children && list[i].children.length > 0) {
							fsroChildCount = fsroChildCount + list[i].children.length;
						}
					}
				}

				return {
					...state,
					[action.response.formSectionId]: {
						fsroTreeList: fsroTreeList,
						newFsroTreeList: newCurrentList,
						fsroParentCount: fsroParentCount,
						fsroChildCount: fsroChildCount
					}
				};
			}
		}

		case types.UPDATE_ITAPPLICATION: {
			const response = action.response;

			if (!response) {
				return state;
			}

			const keys = findEntityUidInsideTree(state, response.id);

			if (!keys) {
				return state;
			}

			let _fsroTreeList = [...state[keys.main].fsroTreeList];

			if (keys.hasOwnProperty('itemChild')) {
				let _children = [...state[keys.main].fsroTreeList[keys.fsroTreeList].children];

				_children[keys.itemChild] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList].children[keys.itemChild],
					entityName: response.itApplicationName
				};

				_fsroTreeList[keys.fsroTreeList] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList],
					children: _children
				};
			} else {
				_fsroTreeList[keys.fsroTreeList] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList],
					entityName: response.itApplicationName
				};
			}

			return {
				...state,
				[keys.main]: {
					...state[keys.main],
					fsroTreeList: _fsroTreeList
				}
			};
		}

		case types.UPDATE_CONTROL: {
			const payload = action.meta.api.data;
			const response = action.response;

			if (!response || action.error) {
				return state;
			}

			const keys = findEntityUidInsideTree(state, payload.id);

			if (!keys) {
				return state;
			}

			let _fsroTreeList = [...state[keys.main].fsroTreeList];

			if (keys.hasOwnProperty('itemChild')) {
				let _children = [...state[keys.main].fsroTreeList[keys.fsroTreeList].children];

				_children[keys.itemChild] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList].children[keys.itemChild],
					entityName: response.controlName,
					designEffectiveness: response.controlDesignEffectivenessTypeId,
					controlTypeId: response.controlTypeId
				};

				_fsroTreeList[keys.fsroTreeList] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList],
					children: _children
				};
			} else {
				_fsroTreeList[keys.fsroTreeList] = {
					...state[keys.main].fsroTreeList[keys.fsroTreeList],
					entityName: response.controlName
				};
			}

			return {
				...state,
				[keys.main]: {
					...state[keys.main],
					fsroTreeList: _fsroTreeList
				}
			};
		}

		default:
			return state;
	}
}

/**
 * Given an array of section related objects, returns the count of objects, grouped by entityId
 * @param {Array} sectionsRelatedObjectReadModelList - Sections related objects array.
 * @returns {Object} an object with the object counts, grouped by entityId. Structure: [{entityId: entityId1, count: count1}, ..., {entityId: entityIdN, count: countN}]
 * */
export function getSectionRelatedObjectTotals(sectionsRelatedObjectReadModelList) {
	let entityCounts = [];

	if (sectionsRelatedObjectReadModelList && sectionsRelatedObjectReadModelList.length > 0) {
		// Get distinct entity types from the collection
		const entityTypes = [...new Set(sectionsRelatedObjectReadModelList.map((fsro) => fsro.entityId))];

		entityCounts = entityTypes.map((entityId) => {
			return {
				entityId: entityId,
				count: sectionsRelatedObjectReadModelList.filter((item) => item.entityId === entityId).length
			};
		});
	}

	return entityCounts;
}

// This will provide the tree level structure when u have to bind the data in straight direction(Ex:Wcgw>Control)
export const GetSectionRelatedObjectTree = (sectionsRelatedObjectReadModelList) => {
	if (sectionsRelatedObjectReadModelList !== undefined && sectionsRelatedObjectReadModelList.length > 0) {
		let sectionRelatedParentObjects = sectionsRelatedObjectReadModelList.filter(
			(obj) => obj.parentFormSectionRelatedObjectId === null
		);

		return BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionsRelatedObjectReadModelList, 1);
	}

	function BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionRelatedObjectList, level, entityName) {
		let sectionRelatedObjectsModel = [];
		sectionRelatedParentObjects.map((parentObject) => {
			parentObject.children = [];
			if (level > 1) {
				parentObject.parentEntityName = entityName;
			}
			let fsro = _.cloneDeep(parentObject);
			let sectionRelatedChildObject = sectionRelatedObjectList.filter(
				(obj) =>
					obj.parentFormSectionRelatedObjectId !== null &&
					obj.parentFormSectionRelatedObjectId === parentObject.formSectionRelatedObjectId
			);

			if (sectionRelatedChildObject !== undefined && sectionRelatedChildObject.length > 0) {
				// Recursive function call to get child for given parent

				fsro.children = BuildSectionRelatedObjectTree(
					sectionRelatedChildObject,
					sectionRelatedObjectList,
					level + 1,
					fsro.entityName
				);
			}
			sectionRelatedObjectsModel.push(fsro);
		});
		return sectionRelatedObjectsModel;
	}
};

// This will provide the tree level structure when we add or remove the entity from UI.
export const GetUpdatedSectionRelatedObjectTree = (sectionsRelatedObjectReadModelList) => {
	if (sectionsRelatedObjectReadModelList !== undefined && sectionsRelatedObjectReadModelList.length > 0) {
		let sectionRelatedParentObjects = sectionsRelatedObjectReadModelList.filter(
			(obj) => obj.parentFormSectionRelatedObjectId === null
		);

		return BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionsRelatedObjectReadModelList, 1);
	}

	function BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionRelatedObjectList, level) {
		let sectionRelatedObjectsModel = [];
		sectionRelatedParentObjects.map((parentObject) => {
			let fsro = _.cloneDeep(parentObject);

			let sectionRelatedChildObject = sectionRelatedObjectList.filter(
				(obj) =>
					obj.parentFormSectionRelatedObjectId !== null &&
					obj.parentFormSectionRelatedObjectId === parentObject.formSectionRelatedObjectId
			);
			if (sectionRelatedChildObject !== undefined && sectionRelatedChildObject.length > 0) {
				// Recursive function call to get child for given parent
				fsro.children = [
					...(parentObject.children || []),
					...BuildSectionRelatedObjectTree(sectionRelatedChildObject, sectionRelatedObjectList, level + 1)
				];
			} else {
				fsro.children = parentObject.children !== undefined ? parentObject.children : [];
			}
			sectionRelatedObjectsModel.push(fsro);
		});

		return sectionRelatedObjectsModel;
	}
};

// This will provide the tree level structure when u have to bind the data in opposite direction.(ITAPP > Control)
// For Ex: I have to show details of (Control)parent which is present in DRO, and children(IT/APP) details in FSRO.
export const GetSectionRelatedObjectTreeForChildToParent = (sectionsRelatedObjectReadModelList) => {
	if (sectionsRelatedObjectReadModelList !== undefined && sectionsRelatedObjectReadModelList.length > 0) {
		let sectionRelatedParentObjects = sectionsRelatedObjectReadModelList.filter(
			(obj) => obj.parentFormSectionRelatedObjectId === null && obj.entityId === entities.Control
		);

		return BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionsRelatedObjectReadModelList, 1);
	}

	function BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionRelatedObjectList, level) {
		let sectionRelatedObjectsModel = [];
		sectionRelatedParentObjects.map((parentObject) => {
			parentObject.children = [];
			let fsro = _.cloneDeep(parentObject);
			let sectionRelatedChildObject = sectionRelatedObjectList.filter(
				(obj) => obj.parentFormSectionRelatedObjectId === null && obj.parentEntityUId === parentObject.entityUId
			);

			if (sectionRelatedChildObject !== undefined && sectionRelatedChildObject.length > 0) {
				// Recursive function call to get child for given parent
				fsro.children = BuildSectionRelatedObjectTree(sectionRelatedChildObject, sectionRelatedObjectList, level + 1);
			}
			sectionRelatedObjectsModel.push(fsro);
		});
		return sectionRelatedObjectsModel;
	}
};

// To remove the object from the store.
export function findObjectAndRemove(dataList, item) {
	// Find object in the current level. If I cant find it, search in the children and remove
	let parentObject,
		data = _.cloneDeep(dataList);

	if (data && data.length > 0) {
		parentObject = data.find(
			(s) => s.entityId === item.parentEntityId && parseInt(s.entityUId) === parseInt(item.parentEntityUId)
		);

		if (parentObject) {
			var index = data.findIndex((s) => {
				return s.entityId === item.parentEntityId && parseInt(s.entityUId) === parseInt(item.parentEntityUId);
			});
			data.splice(index, 1);
		}

		if (!parentObject) {
			for (let i = 0; i < data.length; i++) {
				let indexData = data[i];
				if (indexData.entityId === item.entityId && Number(indexData.entityUId) === Number(item.id)) {
					data.splice(i, 1);
					break;
				}

				let childrenData = data[i].children;
				if (childrenData && childrenData.length > 0) {
					for (let j = 0; j < childrenData.length; j++) {
						let childObject = childrenData.find(
							(s) => s.entityId === item.entityId && Number(s.entityUId) === Number(item.id)
						);
						if (childObject) {
							var index = data[i].children.findIndex((s) => {
								return s.entityId === item.entityId && Number(s.entityUId) === Number(item.id);
							});
							data[i].children = data[i].children.splice(index, 1);

							break;
						}
					}
				}
			}
		}
	}

	return data;
}

/* TO BE REMOVED IF OTHER "findSectionRelatedObjects" FUNCTION WORKS WELL*/
/*
 export function findSectionRelatedObject(state, object) {
	let parentObject;

	if (state && state.length > 0) {
		parentObject = state.find(
			(item) => item.entityId === object.entityId && Number(item.entityUId) === Number(object.entityUId)
		);

		if (!parentObject) {
			for (let i = 0; i < state.length; i++) {
				if (state[i].children) {
					parentObject = findSectionRelatedObject(state[i].children, object);
				}
				if (parentObject) {
					break;
				}
			}
		}
	}

	return parentObject;
}*/

// Find object in the current level. If I cant find it, search for in in the children
export function findSectionRelatedObjects(state, object) {
	let foundFsro = [];

	function recursivelyFindRelatedObjectToUpdate(fsro, item) {
		for (let i = 0; i < fsro.length; i++) {
			if (fsro[i].entityId === item.entityId && Number(fsro[i].entityUId) === Number(item.entityUId)) {
				foundFsro.push(fsro[i]);
			} else {
				if (fsro[i].children && fsro[i].children.length > 0) {
					recursivelyFindRelatedObjectToUpdate(fsro[i].children, item);
				}
			}
		}
	}

	recursivelyFindRelatedObjectToUpdate(state, object);
	return foundFsro;
}
